import QuestionService from '../../services/QuestionService'
import QuestionStepDescriptionService from '../../services/QuestionStepDescriptionService'
import QuestionTypeService from '../../services/QuestionTypeService'
import IntakeService from '../../services/IntakeService'
import _ from 'underscore'
import AnswerService from '../../services/AnswerService'
import {getSelectedOptions, getFailedValidationQuestions} from './Helper'

const actions = {
  getQuestions ({commit, getters, dispatch}) {
    commit('getQuestions')
    QuestionService.getQuestions(getters.getIntakeId)
      .then((res) => {
        commit('getQuestionsSuccess', res.data.questions)
        if (getters.pullFactorsReceived) {
          dispatch('getPullFactors')
        }
      })
      .catch(() => {
        commit('getQuestionsError')
      })
  },

  getQuestionTypes ({commit}) {
    commit('getQuestionTypes')
    QuestionTypeService.getQuestionTypes()
      .then((res) => {
        commit('getQuestionTypesSuccess', res.data.question_types)
      })
      .catch(() => {
        commit('getQuestionTypesError')
      })
  },

  getQuestionStepDescriptions ({commit,}) {
    commit('getQuestionStepDescriptions')
    QuestionStepDescriptionService.getQuestionStepDescriptions()
      .then((res) => {
        commit('getQuestionStepDescriptionsSuccess', res.data.question_step_descriptions)
      })
      .catch(() => {
        commit('getQuestionStepDescriptionsError')
      })
  },

  auth ({commit, dispatch, getters}) {
    commit('auth')
    IntakeService.auth(getters.getIntakeId, getters.getToken)
      .then(() => {
        commit('authSuccess')
          dispatch('getQuestions')
          dispatch('getQuestionTypes')
          dispatch('getQuestionStepDescriptions')
      })
      .catch((error) => {
        let errorMessage = 'Er is iets misgegaan bij het ophalen van de intake'
        if (error.status === 409) {
          errorMessage = 'Intake is reeds afgerond'
        }
        commit('authError', errorMessage)
      })
  },

  addAnswers ({commit, getters}, answers) {
    _.each(answers, (newAnswer) => {
      let answer = getters.getAnswerByQuestionId(newAnswer.question_id)
      if (typeof answer === 'undefined') {
        commit('storeAnswer', newAnswer)
      } else {

        let question = getters.getQuestionByQuestionId(newAnswer.question_id)
        if (getters.isPullFactorQuestion(question)) {
          commit('pullFactorsNotReceived')
        }

        commit('updateAnswer', newAnswer)
      }
    })
  },

  getPullFactors ({getters, commit}) {
    let pullFactorQuestions = getters.getPullFactorQuestions
    let doCall = true
    let postData = {}
    _.each(pullFactorQuestions, (question) => {
      let answer = getters.getAnswerByQuestionId(question.id)
      if (typeof answer === 'undefined' || answer.value === '') {
        doCall = false
        return
      }
      postData[question.type] = answer.value
    })

    if (doCall) {
      commit('getPullFactors')
      IntakeService.getPullFactors(postData)
        .then((res) => {
          commit('getPullFactorsSuccess', res.data)
        })
        .catch(() => {
          commit('getPullFactorsError')
        })
    }
  },

  nextStep ({commit, getters, dispatch}, data) {
    commit('clearValidationErrors')

    if (data.answers.length) {
      dispatch('addAnswers', data.answers)

      if (!getters.pullFactorsReceived) {
        dispatch('getPullFactors')
      }

      let currentQuestions = getters.getCurrentQuestions
      let possibleFunctionNames = getters.getPossibleFunctionNames
      let wrongAnsweredQuestions = getFailedValidationQuestions(
        currentQuestions,
        getters.getAnswers,
        possibleFunctionNames
      )
      if (wrongAnsweredQuestions.length > 0) {
        commit('setValidationErrors', wrongAnsweredQuestions)
        return
      }

      // add followup questions to questionaire
      commit('clearFollowUpQuestions')
      let selectedOptions = getSelectedOptions(data.answers, getters.getOptionsByAnswer)

      _.each(selectedOptions, (selectedOption) => {
        if (+selectedOption.additional_question_id !== 0) {
          let question = getters.getQuestionByQuestionId(selectedOption.additional_question_id)
          if (typeof question !== 'undefined') {
            commit('addFollowUpQuestion', question)
          }
        }
      })
    }

    // complete questionaire or go to the next step
    if (+getters.getCurrentStep === +getters.getTotalSteps) {
      dispatch('storeAnswers', data.answers)
    } else if (getters.getFollowUpQuestions.length === 0) {
      commit('nextStep')
    }
  },
  storeAnswers ({commit, getters}) {
    commit('storeAnswers')
    AnswerService.storeBulk(getters.getAnswers, getters.getIntakeId, getters.getToken)
      .then(() => {
        commit('storeAnswersSuccess')
      })
      .catch(() => {
        commit('storeAnswersError')
      });
  }
}

export default actions
